import { path } from 'ramda';
import { api } from '../../services/api.js';
import { remoteAction } from '../../services/actionService.js';

export const getContent = ({disableCache = false} = {}) => (dispatch, getStore) => {
  const visitId = getStore().global.visitId;
  const cachedAt = path(['content', visitId, 'cachedAt'], getStore());
  if(!disableCache && cachedAt){
    return;
  }

  const action = () => api.get(`/visits/${visitId}/content`).then(({ data }) => data);
  return dispatch(remoteAction({
    type: 'CONTENT_GET',
    action,
    metadata: { visitId }
  }));
};
